<template>
  <v-img
    :src="src"
    class="flex-grow-0 bg-black rounded-xl"
    aspect-ratio="1"
    contain
  />
</template>

<script setup lang="ts">
import { computed, defineProps } from "vue";

const props = defineProps({
  cid: {
    type: String,
    required: true,
  },
});

const src = computed(() => `https://ipfs.superk8s.de/ipfs/${props.cid}`);
</script>
